import React from 'react';
import deletePng from '../../assets/images/delete.png';
import Modal from "react-bootstrap/Modal";

function DeleteModal({deleteShow, handleCancelDelete, handleConfirmDelete}) {
    return (
        <Modal show={deleteShow?.show} centered size='sm' className='deleteModal'>
            <Modal.Body>
                <div className="row">
                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div className="delete-image">
                            <img src={deletePng} alt="deletePng"></img>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div className="confirm-msg mt-3">
                            <h5>Are you sure?</h5>
                            <h6>{deleteShow?.title}</h6>
                            <p className='mt-2'>{deleteShow?.textCode}: <span>{deleteShow?.text}</span></p>
                        </div>
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div className="confirm-btns">
                            <button type="button" className="btn cancel-btn" onClick={handleCancelDelete}>Cancel</button>
                            <button type="button" className="btn delete-confirm-btn" onClick={() => { handleConfirmDelete(deleteShow?.item) }} disabled={deleteShow?.loading}>Delete</button>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default DeleteModal